import mallApi from './api'
import response from 'fe-coms/utils/response'
import Vue from '@/app.js'

const http = new Vue().$http

const action = {
  getCartCount ({commit}) {
    return new Promise((resolve, reject) => {
      let api = mallApi.getCartCount
      response(http(api.type, api.url)).then((result) => {
        if (result.isOk) {
          let cartCount = result.content || 0
          commit('SET_CARTCOUNT', cartCount)
        }
        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default action
